module.exports = __webpack_public_path__ + "media/images/talent/lp/profile01_sp-1292d405ef2a5c958547849ecc2755fa.png";